import { createContext, useContext } from 'react';

export const MAX_COMPARE = 3;

export const CompareContext = createContext({
  items: [],
  has: () => false,
  toggle: () => ({ ok: false }),
  remove: () => {},
  clear: () => {},
  limitMessage: null
});

export function useCompare() {
  return useContext(CompareContext);
}
